import React from "react";
import moment from "moment";
import { Typography } from "antd";
const { Text } = Typography;

const Date = (props) => {
  const { text, format } = props;
  return text !== null ? <Text>{moment(text).format(format)}</Text> : <Text />;
};

export default Date;
